module.exports = __webpack_public_path__ + "img/instagram.ce9459e5.svg";